import { z } from 'zod';

export const UpdateTradeSchema = z
  .object({
    price: z.coerce.number().positive().optional(),
    quantity: z.coerce.number().positive().optional(),
    tradeDate: z
      .string()
      .regex(/^\d{4}-\d{2}-\d{2}$/u, 'Trade date must be YYYY-MM-DD.')
      .optional(),
    notes: z.string().trim().min(1),
  })
  .refine(
    (value) =>
      value.price !== undefined || value.quantity !== undefined || value.tradeDate !== undefined,
    'At least one trade field must be changed.',
  );

export type UpdateTradeInput = z.infer<typeof UpdateTradeSchema>;
